module.exports = "/_next/static/images/logo-aman-2-41f2a005d94dc756a72450521948b715.png";